import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { FaHome } from 'react-icons/fa'
import { MdAdminPanelSettings } from 'react-icons/md'
import { ArrowUturnLeftIcon } from '@heroicons/react/24/solid'
import { LuLogOut } from 'react-icons/lu'
import { useUser } from '../store/userState'

const SideButton = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { user } = useUser()

  const isActiveNavLink = (path) => location.pathname.startsWith(path)

  const handlePreviousPage = () => {
    navigate(-1)
  }

  const role = user?.role

  const handleLogout = () => {
    const confirmLogout = window.confirm('Are you sure you want to log out?')
    if (confirmLogout) {
      localStorage.removeItem('jwt')
      localStorage.removeItem('id')
      navigate('/login')
    }
  }

  const adminActive =
    isActiveNavLink('/adminNXS0011/dashboard') ||
    isActiveNavLink('/adminNXS0011/manage-users') ||
    isActiveNavLink('/adminNXS0011/manage-departments')

  return (
    <nav className="flex flex-col items-center gap-2" aria-label="Primary">
      {role === 'Admin' && (
        <Link
          to="/adminNXS0011/dashboard"
          title="Admin"
          className={`nx-rail-btn ${adminActive ? 'nx-rail-btn-active' : ''} hover:scale-105`}
          aria-current={adminActive ? 'page' : undefined}
        >
          <MdAdminPanelSettings className="h-6 w-6" />
          <span className="sr-only">Admin</span>
        </Link>
      )}

      <Link
        to="/home"
        title="Home"
        className={`nx-rail-btn ${isActiveNavLink('/home') ? 'nx-rail-btn-active' : ''} hover:scale-105`}
        aria-current={isActiveNavLink('/home') ? 'page' : undefined}
      >
        <FaHome className="h-5 w-5" />
        <span className="sr-only">Home</span>
      </Link>

      {!isActiveNavLink('/home') && (
        <button
          type="button"
          title="Go back"
          className="nx-rail-btn hover:scale-105"
          onClick={handlePreviousPage}
        >
          <ArrowUturnLeftIcon className="h-5 w-5" />
          <span className="sr-only">Go back</span>
        </button>
      )}

      <button
        type="button"
        title="Log out"
        onClick={handleLogout}
        className="nx-rail-btn text-muted hover:border-amber/50 hover:text-amber hover:scale-105"
      >
        <LuLogOut className="h-5 w-5" />
        <span className="sr-only">Log out</span>
      </button>
    </nav>
  )
}

export default SideButton
